//Please add the language resource
const distributeView = {
  msg:{
  }
};
export default distributeView



// WEBPACK FOOTER //
// ./src/page/report/distributeView/lang/distributeView.en.js